<div class="page-content">
    <div class="container-fluid">
        <p>basic-table works!</p>
    </div>
</div>